import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { Button, ItemRow, Surface } from '@ukpostbox/frontend-framework';
import { FormatLocaleDateTime } from '@ukpostbox/helpers';
import React from 'react';
import { faDownload } from '@fortawesome/pro-solid-svg-icons/faDownload';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { BatchDocumentEntriesType } from '../../Types/ForwardingBatchTypes';

function BatchDocumentsEntries(props: BatchDocumentEntriesType) {
	const { currentBatchData } = useForwardingBatchProvider();

	if (!currentBatchData || currentBatchData?.shippingDocuments.length === 0) {
		return null;
	}

	return (
		<Surface extraClass='mb-md fb-document-rows'>
			{currentBatchData.shippingDocuments.map((document) => (
				<ItemRow
					key={`shippingDocument${document.file.fileName}`}
					title={`Shipping Document ${document.file.fileName}`}
					static
				>
					<div>{document.file.fileName}</div>
					<div>{document.shippingDocumentType}</div>
					<div>{FormatLocaleDateTime(document.dateCreated)}</div>
					<div className='ml-a'>
						<div className={`${!props.complete ? 'btn-group m-0' : ''}`}>
							{document.file.linkToFile && document.file.linkToFile !== '' && (
								<Button title='Download' icon={faDownload} />
							)}
							{!props.complete && (
								<Button
									title='Delete'
									icon={faTrash}
									onClick={() => props.removeDocumentCallback(document.id)}
									disabled={props.readOnly}
								/>
							)}
						</div>
					</div>
				</ItemRow>
			))}
		</Surface>
	);
}

export { BatchDocumentsEntries };
